import React, { useState } from 'react'
import { Button } from 'antd'
import { Input, Textarea, useTraversal } from '@guillotinaweb/react-gmi'

import { I18NField } from './i18nfield'
import { setLangs } from '../consts'

const seoField = 'api.behaviors.seo.ISeoBehavior'

export function SEOTab({ withH1 }) {
  const Ctx = useTraversal()
  const seo = Ctx.state.context[seoField] || {}
  const [saving, setSaving] = useState(false)
  const [title, setTitle] = useState(seo.seo_title || setLangs(''))
  const [titleH1, setTitleH1] = useState(seo.seo_h1 || setLangs(''))
  const [description, setDescription] = useState(
    seo.seo_description || setLangs('')
  )
  const h1 =
    typeof Ctx.state.context.title === 'string'
      ? Ctx.state.context.title
      : Ctx.state.context['@name']

  async function save() {
    setSaving(true)
    const flashOk = ['SEO fields saved', 'success']
    const flashKo = ['Error saving the SEO fields', 'danger']
    const { status } = await Ctx.client.patch(Ctx.path, {
      [seoField]: {
        seo_title: title,
        seo_description: description,
        seo_h1: titleH1,
      },
    })
    Ctx.flash(...(status === 204 ? flashOk : flashKo))
    setSaving(false)
  }

  return (
    <>
      <div
        style={{
          backgroundColor: 'white',
          display: 'flex',
          padding: 10,
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <h1 className="title is-size-4 is-primary">{h1}</h1>
        <Button type="primary" disabled={saving} onClick={save}>
          {saving ? 'Saving...' : 'Save product'}
        </Button>
      </div>
      <I18NField Widget={() => null}>
        {(lang) => (
          <div style={{ marginTop: 20 }}>
            <Input
              value={title[lang]}
              placeholder="Title"
              id="title"
              onChange={(t) => setTitle((o) => ({ ...o, [lang]: t }))}
            />
            {withH1 && (
              <Input
                value={titleH1[lang]}
                placeholder="Title H1"
                id="h1"
                onChange={(t) => setTitleH1((o) => ({ ...o, [lang]: t }))}
              />
            )}
            <Textarea
              value={description[lang]}
              placeholder="Description"
              id="description"
              onChange={(t) => setDescription((o) => ({ ...o, [lang]: t }))}
            />
          </div>
        )}
      </I18NField>
    </>
  )
}
